@if (!currentSubMenu) {
	<div [ngClass]="{'user-profile-menu': closeSheet}">
		@for (entry of menuEntries; track entry.label) {
			<button mat-menu-item
							(click)="entry.subMenu ? openSubMenu($event, entry) : executeAction(entry)"
							[ngClass]="{'user-profile-menu__button user-profile-menu__button--spaced user-profile-menu__button--with-padding': closeSheet}">
				@if (entry.icon) {
					<mat-icon [ngClass]="{'user-profile-menu__icon': closeSheet}"
										class="me-2 material-symbols-rounded">{{ entry.icon }}
					</mat-icon>
				}
				<span class="d-flex justify-content-between align-items-center w-100"
							[ngClass]="{'user-profile-menu__content': closeSheet}">
				<span [ngClass]="{'user-profile-menu__label mat-body fw-medium': closeSheet}">{{ entry.label }}</span>
					@if (entry.subMenu) {
						<mat-icon class="me-0 material-symbols-rounded">arrow_right</mat-icon>
					}
			</span>
			</button>
		}
	</div>
}

@if (currentSubMenu) {
	<div [ngClass]="{'user-profile-menu user-profile-menu--submenu': closeSheet}">
		<button mat-menu-item (click)="resetSubMenu($event)" [ngClass]="{'user-profile-menu__button': closeSheet}">
			<mat-icon class="me-2 material-symbols-rounded" [ngClass]="{'user-profile-menu--icon-back': closeSheet}">
				arrow_back
			</mat-icon>
			<span class="user-profile-menu__label--submenu-title uik-h5"
						[ngClass]="{'user-profile-menu__label': closeSheet}">{{ subMenuTitle }}</span>
		</button>
		@for (entry of currentSubMenu; track entry.label) {
			<button mat-menu-item (click)="executeAction(entry)" [ngClass]="{'user-profile-menu__button': closeSheet}">
				<span [ngClass]="{'user-profile-menu__label mat-body fw-bold': closeSheet}">{{ entry.label }}</span>
			</button>
		}
	</div>
}
